<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <!-- Overlapping icon -->
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-red-500 rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-log-out text-white text-4xl"></i>
      </div>
    </div>
    <!-- Card content -->
    <div class="px-6">
      <h2 class="text-2xl font-bold text-center mb-1">Sei sicuro di voler uscire?</h2>
      <p class="text-gray-500 text-center mb-4">Questa azione effettuerà il logout. Potrai accedere nuovamente al profilo in qualsiasi momento!</p>
      <div class="flex gap-3 mt-4">
        <CuButton dark class="flex-1" @click="$emit('close')">Annulla</CuButton>
        <CuButton primary class="flex-1" @click="$emit('confirm')">Logout</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "LogoutConfirmSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false }
  }
}
</script>
